import { createReducer } from "@reduxjs/toolkit";
import {
	API_GET_ALL_PREREGISTER_QRCODE,
	API_GET_ALL_PREREGISTER_QRCODE_SUCCESS,
	SET_QR_PREREGISTER,
	API_GET_PREREGISTER_APPOINTMENT_SUCCESS,
	API_GET_RECALLS_PREREGISTER,
	API_GET_RECALLS_PREREGISTER_SUCCESS,
	API_GET_RECALLS_PREREGISTER_FAIL,
	API_GET_PREREGISTERS_LIST_SUCCESS,
	API_GET_PREREGISTERS_LIST,
	API_PATCH_PREREGISTER_WAITING_FLAG,
	API_PATCH_PREREGISTER_WAITING_FLAG_SUCCESS,
	API_GET_PREREGISTER_APPOINTMENT_FAIL,
	API_GET_PREREGISTER_APPOINTMENT,
	API_POST_CHECKIN_SUCCESS,
	API_POST_CHECKIN_FAIL,
} from "actions/preregister";
import { toast } from "react-toastify";
import { getVersion } from "services/preregister";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

const payloadAdapter = (action, currentClient) => {
	const payload = action.payload || {};
	const data = payload.data;

	if (!data) {
		return payload;
	}

	if (currentClient === V2_CLIENT) {
		// Adapt V2 response to match expected format
		// If the response structure is different, adapt it here
		return {
			...payload,
			data: data,
		};
	}

	// Default case - return payload as is
	return payload;
};

const initialState = {
	list: {
		data: [],
		loading: false,
	},
	preregisterQR: null,
	current: null,
	recalls: {
		loading: false,
		data: [],
	},
	adminlist: { loading: false, data: [] },
	adminStats: { loading: false, data: [] },
	secList: { loading: false, data: [] },
	checkin: null,
};

const preregister = createReducer(initialState, {
	[API_GET_ALL_PREREGISTER_QRCODE]: (state, action) => {
		state.list.loading = true;
	},
	[API_GET_ALL_PREREGISTER_QRCODE_SUCCESS]: (state, action) => {
		state.list.loading = false;
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_ALL_PREREGISTER_QRCODE).currentClient;
		const adaptedPayload = payloadAdapter(action, client);
		state.list.data = adaptedPayload.data;
	},
	[SET_QR_PREREGISTER]: (state, action) => {
		state.preregisterQR = action.data;
	},
	[API_GET_PREREGISTER_APPOINTMENT]: (state, action) => {
		state.current = null;
	},
	[API_GET_PREREGISTER_APPOINTMENT_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_PREREGISTER_APPOINTMENT).currentClient;
		const adaptedPayload = payloadAdapter(action, client);
		state.current = adaptedPayload.data;
	},
	[API_GET_PREREGISTER_APPOINTMENT_FAIL]: (state, action) => {
		if (action.error.response.status === 404) toast.error("Aucun dossier trouvé pour cette pré-inscription.");
		else toast.error("Erreur lors de la transformation de la pré-inscription en dossier du centre.");
		state.current = null;
	},
	[API_GET_RECALLS_PREREGISTER]: (state, action) => {
		state.recalls.loading = true;
	},
	[API_GET_RECALLS_PREREGISTER_SUCCESS]: (state, action) => {
		state.recalls.loading = false;
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_RECALLS_PREREGISTER).currentClient;
		const adaptedPayload = payloadAdapter(action, client);
		state.recalls.data = adaptedPayload.data;
	},
	[API_GET_RECALLS_PREREGISTER_FAIL]: (state, action) => {
		state.recalls.loading = false;
	},
	[API_GET_PREREGISTERS_LIST]: (state, action) => {},
	[API_GET_PREREGISTERS_LIST_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_PREREGISTERS_LIST).currentClient;
		const adaptedPayload = payloadAdapter(action, client);
		state.adminlist.data = adaptedPayload.data.preregisters;
		state.adminStats.data = adaptedPayload.data.stats;
		state.adminlist.loading = false;
		state.secList.data = adaptedPayload.data?.secList;
	},
	[API_PATCH_PREREGISTER_WAITING_FLAG_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_PATCH_PREREGISTER_WAITING_FLAG).currentClient;
		const adaptedPayload = payloadAdapter(action, client);
		state.current = adaptedPayload.data;
	},
	[API_POST_CHECKIN_SUCCESS]: (state, action) => {
		toast.success("Le checkin a été envoyé avec succès.");
	},
	[API_POST_CHECKIN_FAIL]: (state, action) => {
		toast.error("Erreur lors de l'envoi du checkin.");
	},
});

export default preregister;
